import { PermissionDenied } from "@/components/flexkit/PermissionDenied";
import { AutomationsPageHeader } from "@/routes/automations/AutomationsPageHeader";
import IconLock from "central-icons/IconLock";
import type { FC } from "react";

export const AutomationsPermissionDeniedPage: FC = () => {
    return (
        <div data-testid="workflows-page" className="flex flex-col gap-6">
            <AutomationsPageHeader />
            <PermissionDenied
                icon={<IconLock size={24} className="text-content-base" />}
                title="You don't have access to Automations"
                description={
                    <>
                        Currently you don&apos;t have permissions to view or manage automations.
                        <br />
                        Please contact your <span className="font-medium">Organization Admin</span> to request access.
                    </>
                }
                data-testid="automations-permission-denied-page"
            />
        </div>
    );
};
